import { createTheme } from '@uhg-abyss/web/tools/theme';
import { createRouter } from '@uhg-abyss/web/tools/createRouter';
import { AbyssProvider } from '@uhg-abyss/web/ui/AbyssProvider';
import { AuthProvider } from '@src/Providers/AuthProvider';
import { Provider } from 'react-redux';
import { appStore } from './store/AppStore';
import { Routes } from './routes';
import { Styles } from './styles/Styles';
import brandOverrides from './theme/brandOverrides';

const ProviderWrapper = () => {
  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  );
};

const theme = createTheme('optum', {
  theme: brandOverrides,
});
const router = createRouter(ProviderWrapper);

export const browser = () => {
  return (
    <Provider store={appStore}>
      <Styles>
        <AbyssProvider theme={theme} router={router} />
      </Styles>
    </Provider>
  );
};
